import React, { useEffect, useState } from "react";
import { Heart, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApp } from "@/store";
import ListingCard from "@/components/ListingCard";

export default function Saved() {
  const { favorites } = useApp();
  const [items, setItems] = useState(null);
  const [subs, setSubs] = useState([]);

  const loadSubs = () => api.get("/subscriptions").then(({ data }) => setSubs(data)).catch(() => {});
  useEffect(() => { api.get("/favorites").then(({ data }) => setItems(data)).catch(() => setItems([])); }, [favorites]);
  useEffect(() => { loadSubs(); }, []);

  const unfollow = async (s) => {
    try { await api.delete("/subscriptions", { params: { category: s.category, country: s.country } }); toast.success("Unfollowed"); loadSubs(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
      <h1 className="flex items-center gap-2 font-display text-3xl font-extrabold tracking-tight"><Heart className="text-[#FF3B30]" /> Saved items</h1>

      <div className="mt-6" data-testid="following-section">
        <div className="mb-2 text-xs font-bold uppercase tracking-widest text-gray-400">Categories you follow</div>
        {subs.length === 0 ? (
          <p className="text-sm text-gray-400" data-testid="following-empty">You don't follow any category yet. Use "🔔 Follow" on the home filters.</p>
        ) : (
          <div className="flex flex-wrap gap-2" data-testid="following-list">
            {subs.map((s) => (
              <span key={`${s.category}-${s.country}`} data-testid={`sub-${s.category}`} className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-gray-50 px-3 py-1.5 text-sm font-semibold capitalize">
                {s.category} {s.country !== "ALL" && <span className="text-xs text-gray-400">· {s.country}</span>}
                <button data-testid={`unfollow-${s.category}`} onClick={() => unfollow(s)} className="text-gray-400 hover:text-[#FF3B30]"><X size={14} /></button>
              </span>
            ))}
          </div>
        )}
      </div>

      {items === null ? (
        <div className="py-24 text-center text-gray-400">Loading…</div>
      ) : items.length === 0 ? (
        <p className="mt-8 text-gray-400" data-testid="saved-empty">You haven't saved any items yet. Tap the heart on a listing to save it.</p>
      ) : (
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="saved-grid">
          {items.map((it, i) => <ListingCard key={it.listing_id} item={it} index={i} />)}
        </div>
      )}
    </div>
  );
}
